import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { getAnalytics, initializeAnalytics } from "firebase/analytics";
import { ReCaptchaV3Provider } from 'firebase/app-check';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getPerformance } from 'firebase/performance';
import app from 'gatsby-plugin-firebase-v9.0';
import React from 'react';
import { theme } from './src/theme';

let perf, analytics;
let functions = getFunctions(app);

export const wrapPageElement = ({ element }) => {
  if (process.env.NODE_ENV === 'development') {
    connectFunctionsEmulator(functions, 'localhost', 5001)
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const appCheck = initializeAnalytics(app, {
      provider: new ReCaptchaV3Provider(
        '6LcQrOkqAAAAAPTeZFszfrbTixNqxkdhlILofxSE'
      ),
      isTokenAutoRefreshEnabled: true,
    })
    perf = getPerformance(app)
    analytics = getAnalytics(app)
  }

  return <MantineProvider theme={theme}>
    <Notifications />
    {element}
  </MantineProvider>;
};